export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Brand.eot?8bed91498d330dfc74c2ddaee3f55ea9";